import React, { useState } from 'react';
import './sidebar-summary.css';
import { Typography } from "@material-ui/core";
import SummaryAccordion from '../summary-accordion/summary-accordion';

const SidebarSummary = ({
    sidebarElements
 }) => {
    const {
		logoInformation,
        laboratoryInformation = null,
        sidebarSummaryAccordion = null
	} = sidebarElements;

    const [isOpen, setIsOpen] = useState(false);

    const openSummary = () => {
        setIsOpen(previousValue => !previousValue);
    };

    const openClass = isOpen ? "show-summary" : "";
    const arrowClass = isOpen ? "active-arrow" : "";

  	return (
		<div className={`sidebar-summary_main ${arrowClass}`}>
            <div className={`sidebar-summary_summary ${openClass}`} >
                <div className={`sidebar-summary_summary--arrowContainer ${arrowClass}`} onClick={openSummary}>
                    <span className={`sidebar-summary_summary--arrow ${arrowClass}`}></span>
                </div>
                <div className={`sidebar-summary_summary--container ${arrowClass}`}>
                    <div className="sidebar-summary_summary--intro">
                        <img
                            src={logoInformation.logoTransparent}
                            width="60%"
                            className="sidebar-summary_summary--icon"
                            alt={logoInformation.alt}
                        />

                        { laboratoryInformation && (
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="logolabTracking col-12">
                                            <img src={laboratoryInformation.lab_logo} width="178" height="120" />
                                        </div>
                                        <div className="col-12 mt-4">
                                            <p className="sidebar-summary_summary--paragraph">
                                                <b>Dúvidas? Entre em contato com o laboratório:</b>
                                                {laboratoryInformation?.telefone && (
                                                    <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
                                                        <strong>Telefone:</strong> {laboratoryInformation.telefone}
                                                    </Typography>
                                                )}
                                                {laboratoryInformation?.email && (
                                                    <Typography variant="body2" color="textSecondary" style={{ marginTop: 2 }}>
                                                        <strong>Email:</strong> {laboratoryInformation.email}
                                                    </Typography>
                                                )}
                                                {laboratoryInformation?.site && (
                                                    <Typography variant="body2" color="textSecondary" style={{ marginTop: 2 }}>
                                                        <strong>Site:</strong> {laboratoryInformation.site}
                                                    </Typography>
                                                )}
                                            </p>
                                            { sidebarSummaryAccordion && (
                                                <SummaryAccordion {...sidebarSummaryAccordion} /> 
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
  	);
};

export default SidebarSummary;